/**
 * API 服务层 - 仅包含 backend.txt 定义的 10 个接口
 */
import api from '@common/api';
import type {
  GetUserLoginStatusParams,
  GetUserLoginStatusResult,
  GetMusicGenreResult,
  CreateUserAccountParams,
  UploadMusicParams,
  UploadMusicResult,
  GetArtistMusicParams,
  GetArtistMusicResult,
  EditMusicParams,
  DeleteMusicParams,
  GetAuditMusicParams,
  GetAuditMusicResult,
  AuditMusicParams,
  ChangeMusicStatusParams,
} from './types';

// 1.1 判断用户是否已经注册
export const getUserLoginStatus = (params: GetUserLoginStatusParams) =>
  api.post<GetUserLoginStatusResult>('rpc/getUserLoginStatus', params);

// 1.2 获取音乐流派和心情
export const getMusicGenre = () =>
  api.get<GetMusicGenreResult>('rpc/getMusicGenre', {});

// 1.3 用户注册
export const createUserAccount = (params: CreateUserAccountParams) =>
  api.post('rpc/createUserAccount', params);

// 1.4 上传单曲音乐
export const uploadMusic = (params: UploadMusicParams) =>
  api.post<UploadMusicResult>('rpc/uploadMusic', params);

// 1.5 获取歌手作品信息
export const getArtistMusic = (params: GetArtistMusicParams) =>
  api.post<GetArtistMusicResult>('rpc/getArtistMusic', params);

// 1.6 编辑歌曲信息
export const editMusic = (params: EditMusicParams) =>
  api.post('rpc/editMusic', params);

// 1.7 删除歌曲
export const deleteMusic = (params: DeleteMusicParams) =>
  api.post('rpc/deleteMusic', params);

// 1.8 获取待审核的歌曲列表
export const getAuditMusic = (params: GetAuditMusicParams) =>
  api.post<GetAuditMusicResult>('rpc/getAuditMusic', params);

// 1.9 审核歌曲
export const auditMusic = (params: AuditMusicParams) =>
  api.post('rpc/auditMusic', params);

// 1.10 更改歌曲的状态
export const changeMusicStatus = (params: ChangeMusicStatusParams) =>
  api.post('rpc/changeMusicStatus', params);

// 导出类型
export * from './types';
